import React, { useState } from 'react';
import { Popover, Button, Card, CardActions } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const BaseFilterPopover = ({ label, children, onApplyFilter, value }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOnApplyFilter = () => {
    onApplyFilter(value);
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'ranged-slider-popover' : undefined;

  return (
    <div>
      <Button
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        sx={{ width: 150 }}
        endIcon={<KeyboardArrowDownIcon />}
      >
        {label}
      </Button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <Card>
          {children}
          <CardActions style={{ justifyContent: 'flex-end' }}>
            {/* <Button variant="outlined">Clear</Button> */}
            <Button variant="outlined" onClick={handleOnApplyFilter}>
              Apply
            </Button>
          </CardActions>
        </Card>
      </Popover>
    </div>
  );
};

export default BaseFilterPopover;
